var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-wrapper field-wrapper--large field-wrapper--checkbox"
    },
    [
      _c("div", { class: [_vm.field.cssClass] }, [
        _vm.field.labelPlacement !== "hidden_label"
          ? _c("p", { staticClass: "label label-checkbox" }, [
              _vm._v("\n      " + _vm._s(_vm.field.label)),
              _vm.field.isRequired ? _c("sup", [_vm._v("*")]) : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "field-group field-group--checkbox" }, [
          _c(
            "div",
            { staticClass: "input-checkbox-wrapper" },
            [
              _vm._l(_vm.field.choices, function(item, choiceKey) {
                return [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.choice,
                        expression: "choice"
                      }
                    ],
                    class: [
                      _vm.field.adminLabel.replace(/ /g, "_"),
                      { "input--content": _vm.field.type === "consent" }
                    ],
                    attrs: {
                      id:
                        "choice-" +
                        _vm.formId +
                        "_" +
                        _vm.fieldKey +
                        "-" +
                        choiceKey,
                      required:
                        _vm.field.type === "consent" && _vm.field.isRequired,
                      name: _vm.field.adminLabel.replace(/ /g, "_"),
                      type: "checkbox"
                    },
                    domProps: {
                      value: item.value,
                      checked: Array.isArray(_vm.choice)
                        ? _vm._i(_vm.choice, item.value) > -1
                        : _vm.choice
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.choice,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = item.value,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.choice = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.choice = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.choice = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      attrs: {
                        for:
                          "choice-" +
                          _vm.formId +
                          "_" +
                          _vm.fieldKey +
                          "-" +
                          choiceKey
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "input-checkbox-text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.field.type === "consent"
                              ? _vm.field.checkboxLabel
                              : item.text
                          )
                        }
                      })
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm._t("description"),
      _vm._v(" "),
      _vm._t("error")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }